export const StateEmtpyActionTypes = {
    STATE_EMPTY_FIRST: '@@auth/STATE_EMPTY_FIRST',
    STATE_EMPTY_SUCCESS: '@@auth/STATE_EMPTY_SUCCESS',
};
